import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import DeliveryReturnMobileModal from "./DeliveryReturnMobileModal";
import "./style.scss";

const DeliveryAndReturnMobile = () => {
  const { t } = useTranslation("productDetails");
  const [modalState, setModalState] = useState(false);

  return (
    <>
      <div className="productDelivery">
        <div className="title" onClick={() => setModalState(true)}>
          <h5>{t("deliveryAndShippingInfo")}</h5>
        </div>
      </div>
      {modalState && (
        <DeliveryReturnMobileModal setModalState={setModalState} />
      )}
    </>
  );
};

export default memo(DeliveryAndReturnMobile);
